export const DPR_DAILY_PROJECT_STATUS = {
  PRODUCTION: 'Production',
  INSTALLATION_FIRING_LINE: 'Firing Line Installation',
  WQT_PRODUCTION_TEST: 'WQT & Production Test',
  /** @deprecated kept so older saved DPR logs still resolve */
  INSTALLATION_PRODUCTION_TEST: 'Installation & Production Test',
};

export const DPR_DAILY_PROJECT_STATUS_OPTIONS = [
  { value: '', label: 'Select status' },
  { value: DPR_DAILY_PROJECT_STATUS.PRODUCTION, label: 'Production' },
  {
    value: DPR_DAILY_PROJECT_STATUS.INSTALLATION_FIRING_LINE,
    label: 'Firing Line Installation',
  },
  {
    value: DPR_DAILY_PROJECT_STATUS.WQT_PRODUCTION_TEST,
    label: 'WQT & Production Test',
  },
];

/** Options for the header dropdown; keeps a legacy saved status visible until changed. */
export const getDprProjectStatusOptions = (currentStatus) => {
  const status = String(currentStatus || '').trim();
  const legacyLabels = {
    [DPR_DAILY_PROJECT_STATUS.INSTALLATION_PRODUCTION_TEST]:
      DPR_DAILY_PROJECT_STATUS.INSTALLATION_PRODUCTION_TEST,
    'Installation firing line': 'Installation firing line',
  };
  if (
    status
    && legacyLabels[status]
    && !DPR_DAILY_PROJECT_STATUS_OPTIONS.some((opt) => opt.value === status)
  ) {
    return [
      ...DPR_DAILY_PROJECT_STATUS_OPTIONS,
      { value: status, label: legacyLabels[status] },
    ];
  }
  return DPR_DAILY_PROJECT_STATUS_OPTIONS;
};

/** Only Production uses / requires an ongoing pipeline. */
const PRODUCTION_PIPELINE_STATUSES = new Set([
  DPR_DAILY_PROJECT_STATUS.PRODUCTION,
]);

/** Ongoing pipeline dropdown is shown only when status is Production. */
export const showOngoingPipelineSelectForStatus = (status) =>
  PRODUCTION_PIPELINE_STATUSES.has(String(status || '').trim());

/** Save, submit, and report generation require an ongoing pipeline for Production only. */
export const statusRequiresOngoingPipelineForReport = (status) =>
  PRODUCTION_PIPELINE_STATUSES.has(String(status || '').trim());

export const buildDprReportContextParams = ({
  ongoingPipelineId,
  dprProjectStatus,
  requireOngoingPipeline = false,
} = {}) => {
  const params = {};
  if (dprProjectStatus) {
    params.dprProjectStatus = dprProjectStatus;
  }
  if (ongoingPipelineId != null && ongoingPipelineId !== '') {
    params.ongoingPipelineId = Number(ongoingPipelineId);
  } else if (requireOngoingPipeline) {
    return null;
  }
  return params;
};

export const ONGOING_PIPELINE_REQUIRED_MESSAGE =
  'Select an ongoing pipeline before generating a report. Set status to Production in the DPR header to choose a pipeline, then save the DPR.';
